import { useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => setCurrentIndex(i => (i + 1) % images.length);
  const prev = () => setCurrentIndex(i => (i - 1 + images.length) % images.length);

  return (
    <div className="relative w-full h-full bg-amber-50">
      <img
        src={images[currentIndex]}
        alt="Kaka"
        className="w-full h-full object-contain transition-all duration-500 ease-in-out"
      />

      {images.length > 1 && (
        <>
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-stone-600 p-2 rounded-full shadow transition-colors"
            aria-label="Fyrri"
          >
            <FaArrowLeft size={12} />
          </button>
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-stone-600 p-2 rounded-full shadow transition-colors"
            aria-label="Næsta"
          >
            <FaArrowRight size={12} />
          </button>

          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`w-1.5 h-1.5 rounded-full transition-colors ${i === currentIndex ? 'bg-[#C29979]' : 'bg-stone-300'}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ImageSlider;
